export const ACTIONS = {
  CREATE_ISF: "create ISF/PSF",
  RESTORE_FILE_FOLDER: "restore file/folder",
  UPDATE_TEMPLATE: "manage templates",
  ADD_TEMPLATE: "manage templates",
  DELETE_TEMPLATE: "manage templates",
  TEMPLATE_MANAGER: "manage templates",
  newFile: "create new file",
  newFolder: "create new folder",
  subFolder: "create sub folder",
  renameFolder: "rename folder",
  lockFile: "lock file",
  unlockFile: "unlock file",
  deleteFile: "delete file",
  deleteFolder: "delete folder",
  moveNode: "move file",
  signFile: "sign file",
  supersededFile: "to see older versions",
  generateCertification: "to generate certification",
  CREATE_COMMENTS: "to make comments",
  DELETE_COMMENTS: "to delete comments",
  restrictedFolder:"to restrict folder",
  ADD_CAPA: "create CAPA",
  CAPA_CONFIGURE: "configure CAPA",
  QMS_CONFIGURE: "configure QMS",
};

export const getPermissionMessage = (action) => {
  return `You do not have permission to perform ${action}. Please contact your administrator.`;
};
